import {
  VISITS_ALL_SORT_CONDITION,
  VISITS_MRN_SORT_CONDITION,
  VISITS_PATIENT_EMAIL_SORT_CONDITION,
  VISITS_PATIENT_NAME_SORT_CONDITION,
  VISITS_PAYMENT_ID_SORT_CONDITION,
  VISITS_PROVIDER_NAME_SORT_CONDITION,
  VISITS_ALL_REQUEST_CONDITION,
  VISITS_MRN_REQUEST_CONDITION,
  VISITS_PATIENT_EMAIL_REQUEST_CONDITION,
  VISITS_PATIENT_NAME_REQUEST_CONDITION,
  VISITS_PAYMENT_ID_REQUEST_CONDITION,
  VISITS_PROVIDER_NAME_REQUEST_CONDITION,
} from '../../utils/constants'

export const text = {
  CANCEL_VISIT: 'Cancel visit',
  RESOLVE_VISIT: 'Resolve visit',
}

export const visitTableView = {
  UPCOMING: 'Upcoming',
  PAST: 'Past',
}

export const routeParam = {
  SEARCH_VALUE: 'searchValue',
  SEARCH_DROPDOWN_OPTION: 'searchDropdownOption',
  DATE_RANGE: 'dateRange',
  VISIT_MODE: 'visitMode',
  VISIT_TYPES: 'visitTypes',
  VISIT_STATUS: 'visitStatus',
  VISIT_TAGS: 'visitTags',
}

export const filterRowTypeAPI = {
  STATUSES: 'Statuses',
  VISIT_TYPES_IDS: 'VisitTypeIds',
  TAGS: 'Tags',
  DRUG_SCREEN_STATUSES: 'DrugScreenStatuses',
  IDENTITY_VERIFICATION_STATUSES: 'IdentityVerificationStatuses',
}

export const UNASSIGNED_PROVIDER_TEXT = 'Unassigned'

export const searchDropdownOptions = [
  { name: VISITS_ALL_SORT_CONDITION, value: VISITS_ALL_REQUEST_CONDITION },
  { name: VISITS_MRN_SORT_CONDITION, value: VISITS_MRN_REQUEST_CONDITION },
  { name: VISITS_PATIENT_EMAIL_SORT_CONDITION, value: VISITS_PATIENT_EMAIL_REQUEST_CONDITION },
  { name: VISITS_PATIENT_NAME_SORT_CONDITION, value: VISITS_PATIENT_NAME_REQUEST_CONDITION },
  { name: VISITS_PAYMENT_ID_SORT_CONDITION, value: VISITS_PAYMENT_ID_REQUEST_CONDITION },
  { name: VISITS_PROVIDER_NAME_SORT_CONDITION, value: VISITS_PROVIDER_NAME_REQUEST_CONDITION },
]
